import { BaseRootEntity } from '@shared/entity/base-root-entity';
import { Dictionary } from '@shared/types';
import { Field } from '@tsim/model';
import { deburr, kebabCase } from 'lodash';

export class ProductGridEntity extends BaseRootEntity {
  @Field(String, true)
  name!: string;

  @Field(String, false)
  shortDescription?: string;

  @Field(String, false)
  url?: string;

  @Field(Number, true)
  price = 0;

  @Field(Number, false)
  standardPrice?: number;

  @Field(Number, false)
  actionPrice?: number;

  @Field(Date, false)
  actionFrom?: Date;

  @Field(Date, false)
  actionTo?: Date;

  @Field(Number, true)
  availability = 3;

  @Field(Number, true)
  stock = 0;

  @Field(String, false)
  defaultImage?: string;

  @Field([String], true)
  images: string[] = [];

  @Field(Object, true)
  params: Dictionary = {};

  @Field(Number, true)
  weight = 0;

  @Field(String, true)
  categoryId!: string;

  @Field(String, true)
  manufacturerId!: string;

  @Field(String, false)
  categoryName = '';

  @Field(String, false)
  manufacturerName = '';

  @Field(Boolean, false)
  buyForbidden = false;

  @Field(String, false)
  ean?: string;

  get shopUrl(): string {
    return this.url || kebabCase(deburr(this.name));
  }

  get isEanValid(): boolean {
    const pattern = /^([0-9]{8}|[0-9]{13,14})$/;
    return pattern.test((this.ean ?? '').trim());
  }
}
